(function () {
function $6074568c9c4450be$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == "text" ? "password" : "text";
            if (input.type == "text") item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector(".password");
        buttonPass.addEventListener("click", handleEvent(div));
    });
}


function $2914c72b259257f0$export$2e2bcd8739ae039() {
    const allFormsErrors = document.querySelectorAll("[id^='form-errors']");
    allFormsErrors.forEach((formErrors)=>showErrors(formErrors));
    function showErrors(formErrors) {
        const errorsText = formErrors.textContent;
        const errors = JSON.parse(errorsText).__all__;
        errors && errors.forEach((error)=>error ? GLOBAL.showToastify(error) : "");
    }
}


function $4833981fa71a468d$export$2e2bcd8739ae039() {
    const breakpoint = window.matchMedia("(min-width:1024px)");
    let swiperPortfolio;
    const breakpointChecker = function() {
        if (breakpoint.matches === true) {
            if (swiperPortfolio !== undefined) swiperPortfolio.destroy(true, true);
            return;
        } else if (breakpoint.matches === false) return enableSwiper();
    };
    const enableSwiper = function() {
        swiperPortfolio = new Swiper(".swiper-portfolio", {
            slidesPerView: 1.2,
            spaceBetween: 8,
            loop: true,
            speed: 10000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false
            },
            pagination: {
                el: "#portfolio .swiper-pagination",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 8
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 8
                }
            }
        });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
}


function $95d9606b27337514$export$2e2bcd8739ae039() {
    const swiperServicosSobre = new Swiper(".swiper-servicos-sobre", {
        slidesPerView: 2.5,
        spaceBetween: 16,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        pagination: {
            el: "#sobre .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                slidesPerView: 4.2,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 5.2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 7,
                spaceBetween: 16
            }
        }
    });
}


function $6ee3df27c4589396$export$2e2bcd8739ae039() {
    const swiperClientes = new Swiper(".swiper-clientes:not(.linha-2)", {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1900: {
                slidesPerView: 5,
                spaceBetween: 16
            }
        }
    });
    const swiperClientes2 = new Swiper(".swiper-clientes.linha-2", {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3.5,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1900: {
                slidesPerView: 4,
                spaceBetween: 16
            }
        }
    });
}


function $97eee76bf2396f98$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-submit");
    contatoFormSubmit && contatoFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            nome: document.querySelector("#nome").value,
            email: document.querySelector("#email").value,
            telefone: document.querySelector("#telefone").value,
            mensagem: document.querySelector("#mensagem").value
        };
        const url = "/fale-conosco/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector(".btn");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }
}


function $4937a915b72f1eb1$export$2e2bcd8739ae039() {
    // TABS PROGRAMACAO 
    const allTabs = document.querySelector(".swiper-programacao-tabs ");
    const allTabsItem = document.querySelectorAll(".swiper-programacao-tabs .tab-programacao ");
    const tabContents = document.querySelectorAll(".programacao-tab-content");
    if (allTabs) allTabs.addEventListener("click", (e)=>{
        const tab = e.target.closest(".tab-programacao");
        if (!tab) return;
        console.log(tab);
        allTabsItem.forEach((item)=>item.classList.remove("active"));
        tab.classList.add("active");
        const tabId = tab.dataset.content;
        tabContents.forEach((t)=>t.classList.remove("active"));
        const contentToShow = document.querySelector(`#${tabId}`);
        console.log(tabId);
        contentToShow.classList.add("active");
    });
    // readmore programacao 
    const readmore = document.querySelectorAll(".continuar-lendo");
    readmore.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            const parent = e.target.closest(".dia-info-wrapper");
            if (parent) parent.classList.toggle("show");
        });
    });
    const swipertabs = new Swiper(".swiper-programacao-tabs", {
        slidesPerView: "auto",
        spaceBetween: 8
    });
    const swiperProgramacaoAtracoes = new Swiper(".swiper-programacao-atracoes", {
        slidesPerView: 1.3,
        spaceBetween: 8,
        breakpoints: {
            768: {
                slidesPerView: 3
            }
        },
        navigation: {
            nextEl: ".dia-atracoes-wrapper .button-right",
            prevEl: ".dia-atracoes-wrapper .button-left"
        }
    });
    const swiperMidia = new Swiper(".swiper-midia", {
        slidesPerView: 1.2,
        spaceBetween: 16
    });
    if (window.innerWidth >= 768) // Destroy the Swiper instance
    swiperMidia.destroy();
    const mql1024 = window.matchMedia("(max-width:1024px)").matches;
    const swiperYoutube = new Swiper(".swiper-youtube", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        navigation: {
            nextEl: "#youtube .button-right",
            prevEl: "#youtube .button-left"
        },
        pagination: {
            el: "#youtube .controls .swiper-pagination",
            dynamicBullets: true,
            clickable: true
        },
        breakpoints: {
            600: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 32
            }
        }
    });
// insert content instagram
}


function $dde89147b3a6dc75$export$2e2bcd8739ae039() {
    const btnMobile = document.getElementById("btn-mobile");
    const headerEl = document.getElementById("header");
    const menuSuperiorInfo = document.querySelector(".menu-superior-info"); // Correção aqui
    const isHome = document.querySelector(".body-home");
    const cepCnpj = document.querySelector("#cep-cnpj-js");
    const formMenu = document.querySelectorAll(".form-menu");
    const linksMenu = document.querySelectorAll("#menu a.link");
    function toggleMenu(event) {
        if (event.type === "touchstart") event.preventDefault();
        const nav = document.getElementById("nav");
        document.body.classList.toggle("menu--open");
        nav.classList.toggle("active");
        const active = nav.classList.contains("active");
        event.currentTarget.setAttribute("aria-expanded", active);
        if (active) event.currentTarget.setAttribute("aria-label", "Fechar menu");
        else event.currentTarget.setAttribute("aria-label", "Abrir menu");
        // Alterna a visibilidade do menuSuperiorInfo
        if (menuSuperiorInfo) menuSuperiorInfo.style.display = active ? "none" : "block";
    }
    // linksMenu.forEach(link => {
    //     link.addEventListener('click', () => {
    //         const nav = document.getElementById('nav');
    //         nav.classList.remove('active');
    //         document.body.classList.remove('menu--open');
    //         // Garante que menuSuperiorInfo reapareça ao fechar o menu
    //         if (menuSuperiorInfo) {
    //             menuSuperiorInfo.style.display = 'block';
    //         }
    //     });
    // });
    linksMenu.forEach((link)=>{
        link.addEventListener("click", (e)=>{
            const parent = link.parentElement;
            const hasSubmenu = parent.querySelector("ul");
            if (window.innerWidth <= 768 && hasSubmenu) {
                // No mobile, ativa submenu em vez de fechar o menu
                e.preventDefault();
                parent.classList.toggle("active");
            } else {
                // Link normal, fecha o menu como de costume
                const nav = document.getElementById("nav");
                nav.classList.remove("active");
                document.body.classList.remove("menu--open");
                if (menuSuperiorInfo) menuSuperiorInfo.style.display = "block";
            }
        });
    });
    if (btnMobile) {
        btnMobile.addEventListener("click", toggleMenu);
        if (headerEl) {
            if (isHome) window.addEventListener("scroll", function() {
                headerEl.classList.toggle("sticky");
            // headerEl.classList.toggle("sticky", window.scrollY > 150);
            });
            else {
                headerEl.classList.add("sticky");
                headerEl.classList.add("is-not-home");
            }
        }
    }
}


function $80fb6b98aeaeaa4f$export$2e2bcd8739ae039() {
    const mql768 = window.matchMedia("(max-width:768px)").matches;
    const swiperMidia = new Swiper(".swiper-midia", {
        slidesPerView: 1.2,
        spaceBetween: 16
    });
    if (!mql768) // Destroy the Swiper instance
    swiperMidia.destroy();
}


function $23d1a14caa12f6a2$export$2e2bcd8739ae039() {
    // FAQ 
    const faqContent = document.querySelector(".content-faq");
    if (faqContent) faqContent.addEventListener("click", (e)=>{
        const faqItems = document.querySelectorAll(".item-faq");
        const faqItem = e.target.closest(".item-faq");
        if (!faqItem) return;
        faqItems.forEach((i)=>i.classList.remove("active"));
        faqItem.classList.add("active");
    });
    // BIGNUMBERS 
    const allNumbers = document.querySelectorAll(".swiper-numeros .numero-item");
    const arrayClasses = [
        "badge-cor-1",
        "badge-cor-2",
        "badge-cor-3",
        "badge-cor-4",
        "badge-cor-5"
    ];
    if (allNumbers) allNumbers.forEach((n, index)=>{
        n.querySelector(".badge-cor").classList.add();
        n.querySelector(".badge-cor").classList.add(arrayClasses[index % arrayClasses.length]);
    });
    const swiperNumeros = new Swiper(".swiper-numeros", {
        slidesPerView: "auto",
        allowTouchMove: false,
        speed: 4000,
        loop: true,
        autoplay: {
            delay: 0
        }
    });
}


function $c7ed91fb2c0221d0$export$2e2bcd8739ae039() {
    const modal = document.querySelector("#modal-atracoes");
    const modalOverlay = document.querySelector("#modal-overlay");
    const closeButton = document.querySelector("#close-button");
    const openButton = document.querySelectorAll(".open-modal-atracao");
    const mainWrapper = document.querySelector("main");
    const oBody = document.body;
    if (modal && modalOverlay && openButton && closeButton) {
        closeButton.addEventListener("click", function() {
            modal.classList.toggle("closed");
            modalOverlay.classList.toggle("closed");
            oBody.classList.toggle("modal-open");
        });
        mainWrapper.addEventListener("click", (e)=>{
            const target = e.target.closest(".open-modal-atracao");
            // console.log(target)
            if (!target) return;
            modal.classList.toggle("closed");
            modalOverlay.classList.toggle("closed");
            oBody.classList.toggle("modal-open");
        });
        // openButton.forEach(btn => {
        //     btn.addEventListener("click", function () {
        //         modal.classList.toggle("closed");
        //         modalOverlay.classList.toggle("closed");
        //         oBody.classList.toggle('modal-open')
        //     });
        // }) 
        modalOverlay.addEventListener("click", (e)=>{
            modal.classList.add("closed");
            modalOverlay.classList.add("closed");
            oBody.classList.toggle("modal-open");
        });
    }
}


function $ac2821ef72d32b9d$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#coming_soon_form");
    contatoFormSubmit && contatoFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            email: document.querySelector("#email").value
        };
        const url = "/cadastro_coming_soon/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector(".btnzin_subnaits");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }
}


function $a2fe33a53a5b512b$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-contato");
    contatoFormSubmit && contatoFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            nome: document.querySelector("#form-contato input[name=nome]").value,
            email: document.querySelector("#form-contato input[name=email]").value,
            mensagem: document.querySelector("#form-contato textarea[name=mensagem]").value
        };
        console.log(form_data);
        const url = "/fale-conosco/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector("#form-contato .button[type=submit]");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }
}


function $62539eb67db9b3dd$export$1594b20a7f5ec825() {
    function footerAnim() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#footer-bienal .grid-sup-footer",
                start: "top+=50px bottom"
            },
            defaults: {
                ease: "none"
            }
        });
        tl.fromTo(".grid-sup-footer .logo-wrapper", {
            clipPath: "inset(0  100% 0 0)"
        }, {
            duration: 1,
            clipPath: "inset(0 0% 0 0)"
        }).from(".grid-sup-footer .socials li", {
            y: 10,
            opacity: 0,
            stagger: 0.2
        }, "<+=0.5").from(".go-top", {
            y: -80
        }, "<");
    }
    function floatingElements() {
        const elements = document.querySelectorAll(".floating-element");
        elements.forEach((el, index)=>{
            setTimeout(()=>{
                const animation = gsap.to(el, {
                    y: 10,
                    duration: 2,
                    yoyo: true,
                    repeat: -1,
                    ease: "none"
                });
            }, 100 * index);
        });
    }
    function animateFrom(elem, direction, isMobile) {
        direction = direction | 1;
        let delay = 0;
        var x = 0, y = 0;
        //direção
        if (elem.classList.contains("animate-left")) {
            x = -100;
            y = 0;
        } else if (elem.classList.contains("animate-right")) {
            x = 100;
            y = 0;
        } else if (elem.classList.contains("animate-down")) y = 150;
        if (isMobile) {
            y = 100;
            x = 0;
        }
        //delay
        if (elem.dataset.delay) delay = `.${elem.dataset.delay}`;
        /* animaçao */ gsap.fromTo(elem, {
            x: x,
            y: y,
            autoAlpha: 0
        }, {
            duration: 1,
            x: 0,
            y: 0,
            autoAlpha: 1,
            delay: delay,
            onComplete: ()=>elem.classList.add("animou")
        });
    }
    function hide(elem) {
        gsap.set(elem, {
            autoAlpha: 0
        });
    }
    function unhide(elem) {
        gsap.set(elem, {
            autoAlpha: 1
        });
    }
    document.addEventListener("DOMContentLoaded", function() {
        var wideScreen = window.matchMedia("(min-width: 800px)");
        var narrowScreen = window.matchMedia("(max-width: 799px)");
        gsap.utils.toArray(".js-animate").forEach(function(elem) {
            hide(elem);
            //     if(wideScreen.matches){
            //         hide(elem); // assure that the element is hidden when scrolled into view
            //     }else {
            //         unhide(elem); // assures that the element is visible when scrolled into view below 800px screen-width
            //   }
            ScrollTrigger.matchMedia({
                "(min-width: 800px)": function() {
                    ScrollTrigger.create({
                        trigger: elem,
                        once: true,
                        start: "top+=50px bottom",
                        // markers: true,
                        onEnter: function() {
                            animateFrom(elem);
                        }
                    });
                },
                "(max-width: 799px)": function() {
                    // The ScrollTriggers created inside these functions are segregated and get
                    // reverted/killed when the media query doesn't match anymore. 
                    ScrollTrigger.saveStyles(".animate-left, .animate-right, .animate-down");
                    ScrollTrigger.create({
                        trigger: elem,
                        once: true,
                        start: "top+=50px bottom",
                        // markers: true,
                        onEnter: function() {
                            animateFrom(elem, 1, "is-mobile");
                        }
                    });
                }
            });
        });
        floatingElements();
        footerAnim();
    });
}


function $794158d2cb9595d4$export$2e2bcd8739ae039() {
    function floatingGirl() {
        const animation = gsap.to(".floating-girl img", {
            y: 10,
            duration: 2,
            yoyo: true,
            repeat: -1,
            ease: "none"
        });
    }
    function gatinhoEnave() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#atracoes",
                start: "top-=150px 90%",
                end: "120px 70%",
                scrub: 1
            },
            defaults: {
                opacity: 0,
                ease: "none"
            }
        });
        tl.from("#atracoes .gatinho-orna  ", {
            opacity: 1,
            y: 130,
            duration: 1.5
        });
        gsap.from("#atracoes .alien-orna ", {
            scrollTrigger: {
                trigger: "#atracoes",
                start: "top-=150px 80%",
                end: "120px 20%",
                scrub: 2
            },
            x: -300,
            opacity: 1
        });
    }
    function gatinhoEnave2() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#programacao .programacao-tab-content",
                start: "top-=50px 90%",
                end: "120px 70%",
                scrub: 1
            },
            defaults: {
                opacity: 0,
                ease: "none"
            }
        });
        tl.from("#programacao .programacao-tab-content .gatinho-orna-2  ", {
            opacity: 1,
            y: 100,
            duration: 1.5
        });
    }
    function bannerPatrocinio() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#banner-patrocinio",
                start: "top+=50px 80%"
            },
            defaults: {
                opacity: 1,
                ease: "none"
            }
        });
        tl.from("#banner-patrocinio .robo-wrapper", {
            y: 200
        });
    }
    function contato() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#contato-footer",
                start: "top+=50px 80%",
                scrub: 2
            },
            defaults: {
                opacity: 1,
                ease: "none"
            }
        });
        // gsap.set('#contato-footer .contato-girl-orna',{ y: -100})
        tl.from("#contato-footer .contato-girl-orna", {
            y: -100
        });
    }
    gatinhoEnave();
    gatinhoEnave2();
    bannerPatrocinio();
    contato();
    floatingGirl();
}


function $ee34b14b151fd95f$export$2e2bcd8739ae039() {
    const counterUp = window.counterUp.default;
    const callback = (entries)=>{
        entries.forEach((entry)=>{
            const el = entry.target;
            if (entry.isIntersecting && !el.classList.contains("is-visible")) {
                counterUp(el, {
                    duration: 1000,
                    delay: 16
                });
                el.classList.add("is-visible");
            }
        });
    };
    const IO = new IntersectionObserver(callback, {
        threshold: 1
    });
    const elArray = document.querySelectorAll(".counter-js");
    elArray.forEach((counter)=>IO.observe(counter));
}


function $f8482878227b673c$export$2e2bcd8739ae039() {
    function intro() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#o-evento",
                start: "top+=50px bottom",
                scrub: 1
            },
            defaults: {
                opacity: 0,
                ease: "back"
            }
        });
        tl.from(".linear img", {
            scaleX: 0.9,
            ease: "none"
        }).from("#o-evento .vertical-items-wrapper > *", {
            y: 50,
            stagger: 0.2,
            duration: 1
        }, "-=0.2");
        gsap.from("#o-evento .col-2 ", {
            x: 200,
            delay: 1.2,
            opacity: 0
        });
        gsap.from("#o-evento  .gatinho-orna", {
            x: 100,
            delay: 1.5
        });
    }
    intro();
}


function $c86aaadf1fefcf52$export$ed80d9de1d9df928() {
    const facebookIcon = document.querySelector("#share-facebook");
    const linkedinIcon = document.querySelector("#share-linkedin");
    const twitterIcon = document.querySelector("#share-twitter");
    const copyIcon = document.querySelector("#share-icon");
    function sharePost(platform) {
        // Get the current post URL or customize it as needed
        const postURL = window.location.href; // Use the current page URL or provide a specific URL
        // Define the share URLs for each platform
        const shareURLs = {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postURL)}`,
            twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(postURL)}`,
            linkedin: `https://www.linkedin.com/sharing/share-offsite/?mini=false&url=${encodeURIComponent(postURL)}&title=${document.title}`
        };
        // Open the share URL in a new window or tab
        window.open(shareURLs[platform], "_blank");
    }
    function copyText() {
        const postURL = window.location.href;
        navigator.clipboard.writeText(postURL).then(()=>{
            console.log("Text copied successfully!");
            // Optionally, show a success message to the user
            GLOBAL.showToastify("Link copiada com sucesso");
        }).catch((error)=>{
            console.error("Tente novamente: ", error);
        // Optionally, show an error message to the user
        });
    }
    document.addEventListener("DOMContentLoaded", ()=>{
        facebookIcon.addEventListener("click", ()=>sharePost("facebook"));
        linkedinIcon.addEventListener("click", ()=>sharePost("linkedin"));
        twitterIcon.addEventListener("click", ()=>sharePost("twitter"));
        copyIcon.addEventListener("click", copyText);
    });
}


function $aab9032fd0080b40$export$2e2bcd8739ae039() {
    const modalWrapper = document.querySelector(".modal-guts");
    const modalAtracoes = document.querySelector("#modal-atracoes");
    const mainWrapper = document.querySelector("main");
    // modalAtracoes.style.height = '530px';
    // REMOVING PROGRAMACAO 
    const BACKUPHTML = `   <div class="programacao">
        <h2 class="title-programacao">programação</h2>


        <div class="wrapper-programacao">
            <div class="section-title">
            <div class="badge-wrapper bg-azul">
                <p class="badge"> <span>24 de setembro</span> • <span class="horario">15hoo</span></p>
            </div>
            </div>
        

            <div class="nome-evento-wrapper">
            <p class="confirmado">Participante confirmado para o evento</p>
            <p class="nome-evento">Nome do evento</p>
            </div>
        </div>
        
    </div>`;
    function formatarData(data) {
        const meses = [
            "JANEIRO",
            "FEVEREIRO",
            "MAR\xc7O",
            "ABRIL",
            "MAIO",
            "JUNHO",
            "JULHO",
            "AGOSTO",
            "SETEMBRO",
            "OUTUBRO",
            "NOVEMBRO",
            "DEZEMBRO"
        ];
        // Separar a data da hora usando o espaço como delimitador
        const [dataPart, horaPart] = data.split(" ");
        // Separar o dia, mês e ano
        const [dia, mes, ano] = dataPart.split("/");
        // Obter o nome do mês formatado
        const nomeMes = meses[parseInt(mes) - 1];
        // Montar a data formatada
        const dataFormatada = `${dia} DE ${nomeMes}`;
        return {
            data: dataFormatada,
            hora: horaPart
        };
    }
    function renderModal(atracao) {
        function compararEventos(a, b) {
            const dataHoraA = new Date(a.data_hora);
            const dataHoraB = new Date(b.data_hora);
            return dataHoraA - dataHoraB;
        }
        const programacaoOrdenada = atracao?.programacao?.sort(compararEventos);
        const modalHTML = `
            <div class="header-wrapper-modal">
        

                <div class="atracao-img-modal">
                    <div class="card-evento-img">
                        <img src="${atracao.imagem}" alt="">
                    </div>
                    <div  class="content">
                        <h2 class="card-evento-title">${atracao.nome}</h2>
                        <p class="card-evento-role">${atracao.funcao}</p>         
                    </div>
                </div>
            
                <div class="infos-tragetoria">
                    <h2>minha trajetória</h2>
                    <div class="paragraphs-content">         
                        <p>
                            ${atracao.descricao.replace(/\r\n/g, "<br>")}
                        </p>

                   
                    </div>
                </div>
            </div>

            <div class="programacao">
                <h2 class="title-programacao">programação</h2>
                <p class="confirmado">Participante confirmado para o evento</p>
                ${programacaoOrdenada && programacaoOrdenada.map((prog)=>{
            const { data: data, hora: hora } = formatarData(prog.data_hora);
            console.log(data, hora);
            let textLocal = "";
            const locais = {
                "Caf\xe9 Liter\xe1rio": "Palco Caf\xe9 Liter\xe1rio P\xf3len",
                "Palco Apoteose": "Palco Apoteose Shell",
                "Pra\xe7a Al\xe9m da P\xe1gina": "Pra\xe7a Al\xe9m da P\xe1gina Shell",
                "Infantil": "Infantil",
                "Audit\xf3rio Ziraldo": "Audit\xf3rio Ziraldo"
            };
            // Verifica se existe a chave e substitui
            if (locais[prog.local]) textLocal = locais[prog.local];
            return `
                        <div class="wrapper-programacao">
                            <div class="section-title">
                                ${textLocal ? `
                                    <div class="badge-wrapper badge-above" >
                                        <p class="badge">${textLocal}</p>
                                    </div>
                                    ` : ""}
                               
                                <div class="badge-wrapper bg-azul  sem-clip">
                                    <p class="badge"> <span>${data}</span> • <span class="horario">${hora}</span></p>
                                </div>
                            </div>
                            
                
                            <div class="nome-evento-wrapper">
                               
                                <p class="nome-evento">${prog.titulo}</p>
                            </div>
                        </div>
                         
                        `;
        }).join("")}                                          
            </div>
          
      


            <div class="atracao-img-modal atracao-img-modal-mobile ">
                <div class="card-evento-img">
                <img src="${atracao.imagem}" alt="">
                </div>
                <div  class="content">
                <h2 class="card-evento-title">${atracao.nome}</h2>
                <p class="card-evento-role">${atracao.funcao}</p>         
                </div>
            </div>
        `;
        modalWrapper.innerHTML = modalHTML;
    }
    function getAtracao(id) {
        const url = `/home/api/atracoes/${id}`;
        axios.post(url).then((response)=>{
            if (response.data) renderModal(response.data);
        }).catch((response)=>{
            console.log(response);
        });
    }
    mainWrapper.addEventListener("click", (e)=>{
        const target = e.target.closest(".open-modal-atracao");
        if (!target) return;
        const card = target.closest(".card-evento");
        const id = card.dataset.id;
        getAtracao(id);
    });
// openButton.forEach(atracao =>{
//     atracao.addEventListener('click', (e) => {
//         const target = e.target.closest('.card-evento');
//         if(!target) return
//         const id = target.dataset.id
//         getAtracao(id);
//     })
// })
}


function $387cb6fd3b6f5399$export$2e2bcd8739ae039() {
    function parseJSONToHTML(json) {
        const data = JSON.parse(json);
        console.log(data);
        let html = "";
        for (const block of data.blocks)switch(block.type){
            case "paragraph":
                html += `<p class="paragraph">${block.data.text}</p>`;
                break;
            case "Header":
                html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                break;
            case "Table":
                html += `<table class="table">${block.data.content}</table>`;
                break;
            case "Raw":
                html += `<div class="raw">${block.data.html}</div>`;
                break;
            case "Delimiter":
                html += '<hr class="delimiter">';
                break;
            case "Code":
                html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                break;
            case "Quote":
                html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                break;
            case "List":
                const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                break;
            case "Embed":
                html += `<div class="embed">${block.data.html}</div>`;
                break;
            case "Checklist":
                const checklistItems = block.data.items.map((item)=>{
                    const checked = item.checked ? "checked" : "";
                    return `<li>
                <input  type="checkbox" onclick="return false;"  ${checked}>
                <label> ${item.text} </label>
                </li>`;
                }).join("");
                html += `<ul>${checklistItems}</ul>`;
                break;
            case "Image":
                html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                break;
            case "Warning":
                html += `<div class="warning">
                            <h3>${block.data.title}</h3>
                            <p>${block.data.message}</p>
                            </div>`;
                break;
            default:
                break;
        }
        return html;
    }
    const blogContent = document.querySelector(".blog-content");
    console.log(blogContent.dataset.conteudo);
    if (blogContent.dataset.conteudo) {
        const htmlParsed = parseJSONToHTML(blogContent.dataset.conteudo);
        console.log(htmlParsed);
        blogContent.innerHTML = htmlParsed;
    } else console.log("SEM CONTEUDO ;");
}


function $5a9a2a7fbd22e317$export$2e2bcd8739ae039() {
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;
    function bannerIntro() {
        if (isMobile) return;
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#quem-somos",
                start: "top+=10px 90%"
            },
            defaults: {
                opacity: 0,
                ease: "back",
                opacity: 0
            }
        });
        gsap.set(".content-for-sobre", {
            "clip-path": "inset( 0 50%)",
            width: 0,
            height: 0
        });
        //  from('#quem-somos .section-title > *', { y: 50, duration: 1, stagger: 0.2})
        tl.from(".info-evento", {
            rotate: 180,
            ease: "none",
            duration: 0.5
        }, "<+=0.5").to(".content-for-sobre", {
            width: "100%",
            duration: 0.6,
            opacity: 1
        }, "-=0.4").to(".content-for-sobre", {
            height: "auto",
            duration: 0,
            opacity: 1
        }, "<+=0.4").to(".content-for-sobre", {
            "clip-path": "inset( 0 0%)",
            opacity: 1
        }, "<").from("#fotos", {
            y: 100,
            opacity: 0
        }, 1);
    //  .to('.info-evento',{ 'justify-content': 'space-between', ease: 'none', opacity: 1, duration: 1} )
    //  .to('.content-for-sobre', { 'clip-path':  'inset( 0 100% 0 0)', width: '100%' ,  opacity: 1 }, '<+=0.5')
    //  .to('.content-for-sobre',{  height: 'auto', duration: 0, opacity: 1}, '<+=0.3' )
    //  .to('.content-for-sobre', { 'clip-path':  'inset( 0 0% 0 0)',  opacity: 1 }, '<')
    }
    bannerIntro();
}


function $66ac328110c8fab9$export$2e2bcd8739ae039() {
    function bannerIntro() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#banner-credenciamento",
                start: "top+=10px 90%"
            },
            defaults: {
                opacity: 0,
                ease: "back",
                opacity: 0
            }
        });
        gsap.set("#banner-credenciamento .main-img-wrapper", {
            "clip-path": "circle(0%)"
        });
        tl.from("#banner-credenciamento .section-title > *", {
            y: 50,
            duration: 1,
            stagger: 0.2
        });
        tl.from("#banner-credenciamento .col-2 > *", {
            y: 50,
            duration: 1,
            stagger: 0.2
        }, "<");
        tl.to("#banner-credenciamento .main-img-wrapper", {
            "clip-path": "circle(100%)",
            opacity: 1,
            duration: 0.8,
            ease: "none"
        }, "<+=0.4");
    }
    bannerIntro();
}


function $54063a1d5a1c34b8$export$2e2bcd8739ae039(inHome = false) {
    const listDatas = document.querySelectorAll(".lista-datas-js");
    const programacoesWrapper = document.querySelector(".programacoes");
    const programacaoWrapperHome = document.querySelector(".programacao-tab-content .grid-wrapper");
    // const pageProgramacaoInfantil = document.querySelector('.programacao-infantil')
    // console.log('Page', pageProgramacaoInfantil);
    function compararPorHorario(evento1, evento2) {
        const horario1 = evento1.info.horario;
        const horario2 = evento2.info.horario;
        return horario1.localeCompare(horario2);
    }
    function renderProgramacao(data) {
        if (!data) return;
        const sortedProgramacao = data.sort(compararPorHorario);
        const programacaoHTML = sortedProgramacao.map((item)=>{
            // .split(':')[0]
            return `
            <div class="programacao">
                <div class="horario-wrapper">
                <p>   às ${item.info.horario}<span class="horario-h">h</span>  </p>
                ${item.info.local ? `    
                <span>-</span>           
                <p class="local"> ${item.info.local}</p>
 
                ` : ""}
                </div>     
             
            
            <div class="dia-atracoes-wrapper">

                <div class="jornada-wrapper">
                    <h2 class="jornada-title"> ${item.info.titulo}</h2>
                    <div class="content-for-p">

                   
                        <p> ${item.info.descricao}</p>

                        <p class="continuar-lendo">
                          Continuar lendo 
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99967 6.66699V13.3337" stroke="#D6DF21" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M13.3337 9.99967H6.66699" stroke="#D6DF21" stroke-linecap="round" stroke-linejoin="round"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17.5V17.5C5.8575 17.5 2.5 14.1425 2.5 10V10C2.5 5.8575 5.8575 2.5 10 2.5V2.5C14.1425 2.5 17.5 5.8575 17.5 10V10C17.5 14.1425 14.1425 17.5 10 17.5Z" stroke="#D6DF21" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                        </p>
                    </div>
                    
                </div>
                <div class="header-atracoes">
                  <p class="header-atracoes-titulo">Atrações</p>
                  <div class="swiper-controls-header">

                    <div class="pagination"></div>
                    <div class="buttons">
                      <svg class="mobile-swiper-icon">
                        <use xlink:href="#icon_mobile-swiper"></use>
                      </svg> 
                      <div class="button button-left">
                        <svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.23828 6.28851L0.76125 3.81248L3.23828 1.33645" stroke="#E2E8ED"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                      </div>
                      <div class="button button-right">
                        <svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.760742 1.33643L3.23777 3.81246L0.760742 6.28849" stroke="#0F0F12"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper swiper-programacao-atracoes">
                  <div class="swiper-wrapper">

                  ${item.data_atracoes.map((atracao)=>{
                return `
                        <div class="swiper-slide">
                            <div class="card-programacao card-evento open-modal-atracao" data-id="${atracao.id}">
                            <div class="card-evento-img">
                                <img src="${atracao.imagem}" alt="${atracao.nome}">
                            </div>
                            <a href="#" class="content">
                                <h2 class="card-evento-title">${atracao.nome}</h2>
                                <p class="card-evento-role">${atracao.funcao}</p>

                            </a>
                            </div>
                        </div>
                    `;
            }).join("")} 
                  </div>
                </div>
            </div>
          </div>
            `;
        }).join("");
        if (programacoesWrapper) programacoesWrapper.innerHTML = programacaoHTML;
        const swiperProgramacaoAtracoes = new Swiper(".swiper-programacao-atracoes", {
            slidesPerView: 1.6,
            spaceBetween: 8,
            breakpoints: {
                768: {
                    slidesPerView: 3.8
                },
                1440: {
                    slidesPerView: 4.5
                }
            },
            pagination: {
                el: ".swiper-programacao-atracoes .swiper-pagination"
            },
            navigation: {
                nextEl: ".dia-atracoes-wrapper .button-right",
                prevEl: ".dia-atracoes-wrapper .button-left"
            }
        });
    }
    function renderProgramacaoInHome(data) {
        if (!data) return;
        const sortedProgramacao = data.sort(compararPorHorario);
        const programacaoHTML = data.map((item)=>{
            // /static/front_assets/src/assets/imagens/carpa.webp
            return `
        <div class="side-info">

        <div class="content-side">
          <div class="img-detail">
          
            <img src="static/front_assets/src/assets/imagens/icons/flor-dali-xl.png" alt="">
          </div>
          <h2 class="programacao-horario">
            Às ${item.info.horario} 
          </h2>
          <h2 class="programacao-local">
          
          ${item.info.local}
          </h2>
        </div>


        <div class="bottom-info">
          <a href="/programacao" class="button-bottom-info">
            VER PROGRAMAÇÃO COMPLETA
            <svg>
              <use xlink:href="#icon_diag-black"> </use>
            </svg>
          </a>
        </div>

      </div>
      <div class="programacao-dia-wrapper">

        <div class="dia-info-wrapper">
          <div class="title">${item.info.titulo} </div>
          <div class="content-for-p"> 
            <p class="descricao ">
              ${item.info.descricao}
            </p>
            <p class="continuar-lendo">
              Continuar lendo

              <svg>
                <use xlink:href="#icon_plus"></use>
              </svg>

            </p>
          </div> 
        </div>
        <div class="dia-atracoes-wrapper">
          <div class="header-atracoes">
            <p class="header-atracoes-titulo">Atrações</p>
            <div class="swiper-controls-header">

              <div class="pagination"></div>
              <div class="buttons">
                <div class="button button-left">
                  <svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.23828 6.28851L0.76125 3.81248L3.23828 1.33645" stroke="#E2E8ED"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>


                </div>
                <div class="button button-right">
                  <svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.760742 1.33643L3.23777 3.81246L0.760742 6.28849" stroke="#0F0F12"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="swiper swiper-programacao-atracoes">
            <div class="swiper-wrapper">
            ${item.data_atracoes.map((atracao)=>{
                return `
              
                  <div class="swiper-slide">
                      <div class="card-programacao card-evento open-modal-atracao" data-id="${atracao.id}">
                      <div class="card-evento-img">
                          <img src="${atracao.imagem}" alt="${atracao.nome}">
                      </div>
                      <a href="#" class="content">
                          <h2 class="card-evento-title">${atracao.nome}</h2>
                          <p class="card-evento-role">${atracao.funcao}</p>

                      </a>
                      </div>
                  </div>
              `;
            }).join("")} 

             
            </div>
          </div>
        </div>
      </div>
        `;
        }).join("");
        if (programacaoWrapperHome) programacaoWrapperHome.innerHTML = programacaoHTML;
        const swiperProgramacaoAtracoes = new Swiper(".swiper-programacao-atracoes", {
            slidesPerView: 1.3,
            spaceBetween: 8,
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl: ".dia-atracoes-wrapper .button-right",
                prevEl: ".dia-atracoes-wrapper .button-left"
            }
        });
    }
    function getProgramacao(data, espaco = "") {
        console.log("DATA ", data);
        console.log("espaco", espaco);
        if (!data) return;
        // let url = ''
        //   if(pageProgramacaoInfantil)
        //     url = `/home/api/programacao-dia/?espaco=Infantil&data=${data}`
        //   else
        const url = `/home/api/programacao-dia/?data=${data}&espaco=${espaco}`;
        //const url = `/home/api/programacao-dia/?data=${data}&espaco=${espaco}`
        //const url = `/home/api/programacao-dia/?espaco=Infantil&data=${data}`
        axios.get(url).then((response)=>{
            if (response.data) {
                if (inHome) renderProgramacaoInHome(response.data);
                else renderProgramacao(response.data);
            }
        }).catch((response)=>{
            console.log(response);
        });
    }
    listDatas && listDatas.forEach((data)=>{
        data.addEventListener("click", (e)=>{
            const target = e.target.closest(".lista-datas-js");
            if (!target) return;
            listDatas.forEach((i)=>i.classList.remove("active"));
            target.classList.add("active");
            const data = target.dataset.diaEvento;
            const selectLabel = document.querySelector(".selected-espaco");
            const espaco = selectLabel.dataset.espacoSelecionado;
            const novaURL = `${window.location.origin}${window.location.pathname}?espaco=${espaco}&data=${data}`;
            const urlInfantil = `${window.location.origin}${window.location.pathname}?espaco=Infantil&data=${data}`;
            // if (pageProgramacaoInfantil){
            //     console.log('url infantil', urlInfantil);
            //     window.history.pushState({}, '', urlInfantil); 
            //     getProgramacao(data , espaco);
            // } else if (!pageProgramacaoInfantil){
            window.history.pushState({}, "", novaURL);
            getProgramacao(data, espaco);
        });
    });
    const primeiraData = document.querySelector(".lista-datas-js");
    const urlParams = new URLSearchParams(window.location.search);
    const espaco = urlParams.get("espaco");
    const dataParam = urlParams.get("data");
    if (primeiraData) {
        const data = primeiraData.dataset.diaEvento;
        listDatas.forEach((item)=>{
            const data = item.dataset.diaEvento;
            console.log(data, "A");
            if (dataParam == data) {
                listDatas.forEach((item)=>{
                    item.classList.remove("active");
                });
                item.classList.add("active");
            }
        });
        if (espaco) {
            const selectLabel = document.querySelector(".selected-espaco");
            selectLabel.dataset.espacoSelecionado = espaco;
            const itemLabel = document.querySelector(`.espaco-item[data-espaco='${espaco}']`);
            selectLabel.innerHTML = itemLabel?.innerText;
        }
        if (dataParam && espaco) getProgramacao(dataParam, espaco);
        else if (dataParam) getProgramacao(dataParam);
        else getProgramacao(data);
        console.log(espaco, dataParam, data);
    }
    const filtrarPorEspaco = document.querySelector(".filtrar-por-espaco");
    const espacos = document.querySelector(".espacos");
    const setaPesquisa = document.querySelector(".svg-pesquisa");
    const selectLabel = document.querySelector(".selected-espaco");
    if (filtrarPorEspaco) {
        filtrarPorEspaco.addEventListener("click", ()=>{
            espacos.classList.toggle("open");
            setaPesquisa.classList.toggle("active");
        });
        const items = document.querySelectorAll(".espaco-item");
        items.forEach((option)=>{
            option.addEventListener("click", ()=>{
                selectLabel.innerHTML = option.innerText;
                const espacoQuery = option.dataset.espaco;
                selectLabel.dataset.espacoSelecionado = espacoQuery;
                // console.log(espacoQuery)
                const dataElAtivo = document.querySelector(".lista-datas-js.active");
                const dataAtiva = dataElAtivo.dataset.diaEvento;
                const novaURL = `${window.location.origin}${window.location.pathname}?espaco=${espacoQuery}&data=${dataAtiva}`;
                window.history.pushState({}, "", novaURL);
                getProgramacao(dataAtiva, espacoQuery);
                espacos.classList.remove("open");
                setaPesquisa.classList.remove("active");
            });
        });
    }
}


function $4928a42df9327267$export$2e2bcd8739ae039() {
    const modalInner = document.querySelector(".modal-guts");
    const modalWrapper = document.querySelector(".modal-atracoes");
    const closeModal = document.querySelector("#close-button");
    // const data = [{
    //     nome: 'localizacao',
    //     Localizacao: 'teste'
    //     }
    // ]
    const expositores = document.querySelectorAll(".expositor-item");
    function rendermodalContentOne(data) {
        console.log(data);
        const { info: info, programacao: programacao } = data;
        console.log(info);
        console.log(programacao);
        function compararEventos(a, b) {
            const dataHoraA = new Date(`${a.data}T${a.horario}`);
            const dataHoraB = new Date(`${b.data}T${b.horario}`);
            return dataHoraA - dataHoraB;
        }
        const programacaoOrdenada = programacao?.sort(compararEventos);
        console.log("ordenada", programacaoOrdenada);
        const htmlStepOne = ` 
        <div class="step-1-item">
      
        <div class="header-expositor">
        <div class="header-1-wrapper ">
            <div class="nome-wrapper">
                <p class="info-label" >Nome</p>
                <p class="info-nome">${info?.nome}</p>
            </div>  
            <div class="button-wrapper go-to-2">
                <button class="button">Ver programação</button>
            </div>  
        </div>
        <div class="header-2-wrapper ">
            
                <div class="nome-wrapper">
                    <p class="info-label" >localização</p>
                    <p class="info-nome">${info?.local}</p>
                </div>
                <div class="nome-wrapper">
                    <p class="info-label" >pavilhão</p>
                    <p class="info-nome">${info?.pavilhao}</p>
                </div>
            
            
        </div>         
    </div>
    <div class="button-wrapper only-mobile-btn go-to-2">
        <button class="button">Ver programação</button>
    </div> 

    <div class="informacoes-wrapper">
        <div class="col-1 selos">
            <div class="section-title">
                <div class="badge-wrapper bg-azul" >
                <p class="badge ">selos</p>
                </div>
            </div>
            <ul>
            ${info?.selos?.map((selo)=>{
            return `<li>${selo}</li>`;
        }).join("")}
               
            </ul>
        </div>
        <div class="col-2 livros">
            <div class="section-title">
                <div class="badge-wrapper bg-azul" >
                <p class="badge ">livros mais procurados</p>
                
                </div>
            </div>
            <ul class="livros-wrapper">
                ${info?.livros?.map((livro)=>{
            return ` <li>
                            <div class="img-wrapper">
                                <img src="${livro?.imagem}" alt="">
                            </div>
                            <p class="nome-livro">${livro?.nome}</p>
                        </li>`;
        }).join("")}            
            </ul>
        </div>
      </div> 
    </div> 
    

    <div class="step-2-item">
        <div class="header-expositor step-2">
            <button class="flex items-center voltar-btn go-to-1"> 
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16602 10.0002H15.8327" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.33268 5.8335L4.16602 10.0002" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.33268 14.1667L4.16602 10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>VOLTAR</span>
            </button>

            <p class="info-nome">programação</p>
            <p class="confirmada-title">Atração confirmada para o evento</p>
        </div>

        <div class="lista-programacao">
            <ul>

            ${programacaoOrdenada.length > 0 ? programacaoOrdenada?.map((item)=>{
            const dataCriada = new Date(item.data);
            const dataFormatada = dataCriada.toLocaleDateString("pt-BR", {
                timeZone: "UTC"
            });
            console.log(dataFormatada);
            return `   <li>
                        <div class="section-title">
                            <div class="badge-wrapper bg-azul" >
                                <p class="badge ">${dataFormatada} • ${item?.horario}</p>
                            </div>
                            <div class="informacoes">
                                <div class="group-1">
                                    <div class="group">
                                        <p class="label">Espaço</p>
                                        <p class="info-nome">${item?.espaco}</p>
                                    </div>
                                    <div class="group">
                                        <p class="label">sessão</p>
                                        <p class="info-nome">${item?.tipo_sessao ? item.tipo_sessao : "-"}</p> 
                                    </div>
                                    <div class="group">
                                        <p class="label">autor/participante</p>
                                        <p class="info-nome">${item?.participante}</p>
                                    </div>
                                </div>
                                
                                <div class="group">
                                    <p class="label">Descrição</p>
                                    <p class="info-nome">${item?.descricao}</p>
                                </div>
                                
                            </div>
                        </div>
                    </li>`;
        }).join("") : ""}

            ${programacaoOrdenada.length == 0 ? `<p> Em breve!</p>` : ""}  
            </ul>
        </div>
    </div>
    `;
        modalInner.innerHTML = htmlStepOne;
    }
    function getExpositor(id) {
        //  alert('ID: '+ id )
        const url = `/home/api/expositor/${id}`;
        axios.post(url).then((response)=>{
            console.log(response);
            if (response.data) rendermodalContentOne(response.data);
        }).catch((response)=>{
            console.log("erro ?");
            console.log(response);
        });
    }
    expositores.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            const target = e.target.closest(".expositor-item");
            if (!target) return;
            const id = target.dataset.expositorId;
            // expositores.target
            getExpositor(id);
        });
    });
    if (closeModal) closeModal.addEventListener("click", ()=>{
        modalWrapper.classList.add("active-step-1");
        modalWrapper.classList.remove("active-step-2");
    });
    modalInner.addEventListener("click", (e)=>{
        const target = e.target;
        const target1 = target.closest(".go-to-1");
        const target2 = target.closest(".go-to-2");
        //  console.log(target)
        console.log(target1);
        console.log(target2);
        // console.log(target1)
        // console.log(target2)
        // if(target1 || !!target2) return
        if (target1) {
            modalWrapper.classList.add("active-step-1");
            modalWrapper.classList.remove("active-step-2");
        } else if (target2) {
            modalWrapper.classList.remove("active-step-1");
            modalWrapper.classList.add("active-step-2");
        } else return;
    });
}


function $e8377eab04c0a9e6$export$2e2bcd8739ae039() {
    if (window.matchMedia("(max-width: 1100px)").matches) return;
    gsap.registerPlugin(ScrollTrigger);
    const cardsWrapper = document.querySelector("#galeria .cards-wrapper");
    if (!cardsWrapper) return;
    const col1 = cardsWrapper.querySelector(".col-1"), col2 = cardsWrapper.querySelector(".col-2");
    const value = 300, duration = 50;
    gsap.set(col1, {
        x: -value
    }, "juntas");
    gsap.set(col2, {
        x: value
    }, "juntas");
    const tl = gsap.timeline({
        paused: true,
        delay: 0,
        ease: "linear",
        repeat: 1,
        yoyo: true,
        yoyoEase: false
    }).to(col1, {
        duration: duration,
        x: value
    }, "juntas").to(col2, {
        duration: duration,
        x: -value
    }, "juntas");
    window.tl = tl;
    ScrollTrigger.create({
        trigger: cardsWrapper,
        once: false,
        start: "top-=100px",
        refreshPriority: 10,
        //markers: true,
        onEnter: function() {
            tl.play();
        }
    });
}


function $2e64670dfff08bd8$export$2e2bcd8739ae039(inHome = false) {
    const imageWrapper = document.querySelector(".image-galeria-wrapper");
    const sidebar = document.querySelectorAll(".sidebar li");
    const renderImage = (data)=>{
        const img = data.map((i)=>{
            return `
            <a href="${i.url}" data-fancybox="youtube">
                <img src="${i.url}" alt="item-galeria">
            </a>
        `;
        }).join("");
        imageWrapper.innerHTML = img;
    };
    function getProgramacao() {
        // if(!data) return
        const url = `${window.location.origin}/home/api/galeria-semfiltro-json`;
        axios.get(url).then((response)=>{
            if (response.data) {
                console.log("Data:", response.data);
                renderImage(response.data);
            }
        }).catch((response)=>{
            console.log(response);
        });
    }
    window.addEventListener("DOMContentLoaded", ()=>{
        // console.log(window.history.pushState({}, '',`${window.location.origin}/home/api/galeria-semfiltro-json`)); 
        // window.location.replace(location.href)
        getProgramacao();
    });
} /*
CODE VERSÃO 1

const selectItemMenu = () => {
    sidebar.forEach(item =>{ 
        item.addEventListener('click', ()=>{
            sidebar.forEach(i =>{
                i.classList.remove('active');
            })
            item.classList.toggle('active');
            redirectUrl(item)             
        })
    })
}

const redirectUrl = (item) => {
    const diaEvento = item.dataset.diaEvento
    const novaURL = `${window.location.origin}${window.location.pathname}?data=${diaEvento}`;
    window.history.pushState({}, '', novaURL); 
    window.location.replace(location.href)
}


const reloadPage = () => {
    sidebar.forEach(item =>{
    if (!window.location.href.includes('?data=')){
            const diaEvento = item.dataset.diaEvento
            const novaURL = `${window.location.origin}${window.location.pathname}?data=${diaEvento}`;
            console.log('data',item.dataset, item);
            window.history.pushState({}, '', novaURL); 
            window.location.replace(location.href)
            activateItem(window.location.href, item)    
        }   
        activateItem(window.location.href, item)    
    })
    selectItemMenu()
}

const activateItem = (url, item) => {
    if (url.includes(`?data=${item.dataset.diaEvento}`))
        item.classList.toggle('active');
}

reloadPage()

*/  /*

const selectItemMenu = () => {
    sidebar.forEach(item =>{ 
        item.addEventListener('click', ()=>{
            sidebar.forEach(i =>{
                i.classList.remove('active');
            })
            item.classList.toggle('active');
            const diaEvento = item.dataset.diaEvento
            const novaURL = `${window.location.origin}${window.location.pathname}?data=${diaEvento}`;
            console.log('data',item.dataset, item);
            window.history.pushState({}, '', novaURL); 
            getProgramacao(diaEvento)
        })
    })
}

const renderImage = (data) => {
    const img = data.map(i =>{
        return `
            <a href="${i.url}" data-fancybox="youtube">
                <img src="${i.url}" alt="item-galeria">
            </a>
        `
    }).join('')
   imageWrapper.innerHTML = img
}

function getProgramacao(data){

if(!data) return

const  url = `/home/api/galeria-json?data=${data}`
    axios.get(url)
        .then((response) => {
            if(response.data){
                renderImage(response.data)
            }
        })
        .catch((response) => {
            console.log(response)  
        });
}

window.addEventListener('DOMContentLoaded',()=>{

    sidebar.forEach(item =>{
        if (!window.location.href.includes(`?data=`)){
            if(item.classList.contains('active'))
                window.history.pushState({}, '',`${window.location.origin}${window.location.pathname}?data=${item.dataset.diaEvento}`); 
                getProgramacao(item.dataset.diaEvento)
        }

        else if (window.location.href.includes(`?data=${item.dataset.diaEvento}`)){
            sidebar.forEach(i =>{
                i.classList.remove('active');
            })
                item.classList.toggle('active');
                getProgramacao(item.dataset.diaEvento)
        }
    }) 
        selectItemMenu()
})
*/ 


function $afa81d98f5c9aac5$export$2e2bcd8739ae039() {
    const listDatas = document.querySelectorAll(".lista-datas-js");
    const programacoesWrapper = document.querySelector(".conteudo-programacao-js");
    const programacaoExpositores = document.querySelector(".programacao-expositores");
    const programacaoAutografos = document.querySelector(".programacao-autografos");
    const filtrarSearchInput = document.querySelector(".filtrar-por-espaco-input");
    function renderProgramacaoExpositores(data) {
        if (!data) return;
        const resultadosOrdenados = data.results.sort((a, b)=>a.horario.localeCompare(b.horario));
        const programacaoHTML = resultadosOrdenados.map((item)=>{
            const { id: id, expositor: expositor, descricao: descricao, espaco: espaco, tipo_sessao: tipo_sessao, descricao_editora: descricao_editora, participante: participante, acoes: acoes, classificao_etaria: classificao_etaria, publico_estimado: publico_estimado, data: data, horario: horario, status: status } = item;
            return `
             <div class="card-programacao-expositor">
                    <div class="flex-between">

                        <h2 class="title one-line" >${expositor}</h2>
                        <div class="card-expositor-horario">
                            <svg style="width: 20px; height: 20px;">
                                <use xlink:href="#icon-horario"></use>
                            </svg>
                            <span> às ${horario?.split(":").slice(0, 2).join(":")}</span>
                        </div>
                    </div>
                    <div class="grid-cards-expositores">
                        <div class="card-base">
                            <p class="label">espaço</p>

                            <h3 class="descricao">
                                ${espaco ? espaco : "-"}
                            </h3>
                        </div>
                        <div class="card-base">
                            <p class="label">sessão</p>

                            <h3 class="descricao">
                                ${tipo_sessao ? tipo_sessao : "-"}
                            </h3>
                        </div>
                        <div class="card-base">
                            <p class="label">autor/participante</p>

                            <h3 class="descricao">
                                ${participante ? participante : "-"}
                            </h3>
                        </div>
                        ${descricao ? `
                            <div class="card-base" style="grid-column: 1 / -1;">
                                <p class="label">descrição</p>

                                <h3 class="descricao">
                                    ${descricao}
                                </h3>
                            </div>
                            ` : ""}
                          
                    </div>
                </div>
            `;
        }).join("");
        if (programacoesWrapper) {
            if (programacaoHTML) programacoesWrapper.innerHTML = programacaoHTML;
            else programacoesWrapper.innerHTML = `
                <p style="font-size: 18px; ">
                    Nenhum Expositor encontrado para essa data
                </p>`;
        }
    }
    function renderProgramacaoAutografos(data) {
        if (!data) return;
        const resultadosOrdenados = data.results.sort((a, b)=>a.horario.localeCompare(b.horario));
        const programacaoHTML = resultadosOrdenados.map((item)=>{
            const { id: id, atracao: atracao, espaco: espaco, horario: horario, imagem: imagem, ordem: ordem, quantidade_autografo: quantidade_autografo } = item;
            return `
             <div class="card-programacao-expositor">
                <div class="flex-autografos">
                    <div class="col-1">
                        <div class="card-evento-img">
                                ${imagem ? `<img src='${imagem}' alt="">` : `<img src='http://placehold.co/280x280.png' alt="">`}
                            
                        </div>
                    </div>
                


                    <div class="col-2">
                    <div class="flex-between">

                        <h2 class="title one-line" > ${atracao} </h2>
                        <div class="card-expositor-horario">
                            <svg style="width: 20px; height: 20px;">
                                <use xlink:href="#icon-horario"></use>
                            </svg>
                            <span> às ${horario?.split(":").slice(0, 2).join(":")}</span>
                        </div>
                    </div>
                    <div class="">
                        <div class="card-base">
                            <p class="label">local</p>

                            <h3 class="descricao">
                                ${espaco ? espaco : "-"}
                            </h3>
                        </div>
                       
                        
                    </div>
                    </div>
                </div>
            </div>
            `;
        }).join("");
        if (programacoesWrapper) {
            if (programacaoHTML) programacoesWrapper.innerHTML = programacaoHTML;
            else programacoesWrapper.innerHTML = `
                <p style="font-size: 18px; ">
                    Nenhum Autor encontrado para essa data
                </p>`;
        }
    }
    function getProgramacao(data, search = "") {
        if (!data) return;
        const urlApi = programacaoExpositores ? "expositores-programacao" : programacaoAutografos ? "programacao-autografo" : "";
        if (!urlApi) return;
        const url = `/api/${urlApi}/?data=${data}&search=${search}`;
        axios.get(url).then((response)=>{
            if (response.data) {
                if (programacaoExpositores) renderProgramacaoExpositores(response.data);
                else if (programacaoAutografos) renderProgramacaoAutografos(response.data);
                console.log("response", response.data);
            // if(inHome){
            //   renderProgramacaoInHome(response.data);
            // }else{
            //   renderProgramacao(response.data)
            // }
            }
        }).catch((response)=>{
            console.log("error", response);
        });
    }
    listDatas && listDatas.forEach((data)=>{
        data.addEventListener("click", (e)=>{
            const target = e.target.closest(".lista-datas-js");
            if (!target) return;
            listDatas.forEach((i)=>i.classList.remove("active"));
            target.classList.add("active");
            const data = target.dataset.diaEvento;
            const inputPesquisa = document.querySelector(".input-pesquisa");
            // const espaco = selectLabel.dataset.espacoSelecionado
            const novaURL = `${window.location.origin}${window.location.pathname}?search=${inputPesquisa?.value ? inputPesquisa.value : ""}&data=${data}`;
            // if (pageProgramacaoInfantil){
            //     console.log('url infantil', urlInfantil);
            //     window.history.pushState({}, '', urlInfantil); 
            //     getProgramacao(data , espaco);
            // } else if (!pageProgramacaoInfantil){
            window.history.pushState({}, "", novaURL);
            getProgramacao(data, inputPesquisa?.value ? inputPesquisa.value : "");
        });
    });
    function formSearch() {
        if (!filtrarSearchInput) return;
        filtrarSearchInput.addEventListener("submit", (e)=>{
            e.preventDefault();
            const inputPesquisa = document.querySelector(".input-pesquisa");
            if (inputPesquisa) {
                const search = inputPesquisa.value;
                const data = document.querySelector(".lista-datas-js.active")?.dataset.diaEvento;
                getProgramacao(data, search);
            }
        });
    }
    function init() {
        const urlParams = new URLSearchParams(window.location.search);
        const data = urlParams.get("data");
        const search = urlParams.get("search");
        const inputPesquisa = document.querySelector(".input-pesquisa");
        formSearch();
        if (data) {
            listDatas.forEach((i)=>i.classList.remove("active"));
            const dataAtiva = document.querySelector(`.lista-datas-js[data-dia-evento="${data}"]`);
            dataAtiva && dataAtiva.classList.add("active");
            getProgramacao(data, search ? search : inputPesquisa?.value ? inputPesquisa.value : "");
        } else getProgramacao(listDatas[0]?.dataset.diaEvento, search ? search : inputPesquisa?.value ? inputPesquisa.value : "");
    }
    init();
}


const $ad253d60d7afe5ec$var$pageHome = document.querySelector(".body_home");
const $ad253d60d7afe5ec$var$pageBlog = document.querySelector(".body_blog");
const $ad253d60d7afe5ec$var$pageSingle = document.querySelector(".body_single_blog");
const $ad253d60d7afe5ec$var$pageOevento = document.querySelector(".body-o-evento");
const $ad253d60d7afe5ec$var$pageQuemSomos = document.querySelector(".body_quemsomos");
const $ad253d60d7afe5ec$var$pageProgramacao = document.querySelector(".body_programacao");
const $ad253d60d7afe5ec$var$pageAtracoes = document.querySelector(".body_eventos ");
const $ad253d60d7afe5ec$var$pageComingSoon = document.querySelector(".body-coming-soon");
const $ad253d60d7afe5ec$var$pageContato = document.querySelector(".body_contato");
const $ad253d60d7afe5ec$var$pageVisitantes = document.querySelector(".body_infos");
const $ad253d60d7afe5ec$var$pageCredenciamento = document.querySelector(".body_credenciamento");
const $ad253d60d7afe5ec$var$pageEspacos = document.querySelector(".body_espacos");
const $ad253d60d7afe5ec$var$pageServicos = document.querySelector(".body_servicos");
const $ad253d60d7afe5ec$var$pageExpositores = document.querySelector(".body_expositores");
const $ad253d60d7afe5ec$var$pageProgramacaoExpositorEAutografros = document.querySelector(".body_programacao_expositor");
(0, $6074568c9c4450be$export$2e2bcd8739ae039)();
(0, $2914c72b259257f0$export$2e2bcd8739ae039)();
(0, $2e64670dfff08bd8$export$2e2bcd8739ae039)();
(0, $e8377eab04c0a9e6$export$2e2bcd8739ae039)();
gsap.registerPlugin(ScrollTrigger);
(0, $4833981fa71a468d$export$2e2bcd8739ae039)();
(0, $95d9606b27337514$export$2e2bcd8739ae039)();
(0, $6ee3df27c4589396$export$2e2bcd8739ae039)();
(0, $97eee76bf2396f98$export$2e2bcd8739ae039)();
(0, $dde89147b3a6dc75$export$2e2bcd8739ae039)();
// ★ Pages Scopo
(0, $c7ed91fb2c0221d0$export$2e2bcd8739ae039)();
(0, $62539eb67db9b3dd$export$1594b20a7f5ec825)();
(0, $ee34b14b151fd95f$export$2e2bcd8739ae039)();
const $ad253d60d7afe5ec$var$swiperPatrocinadores = new Swiper(".swiper-banner-patrocinadores", {
    spaceBetween: 16,
    pagination: {
        el: ".swiper-banner-patrocinadores .swiper-pagination",
        clickable: true,
        type: "bullets"
    },
    autoplay: {
        delay: 3000
    }
});
const $ad253d60d7afe5ec$var$swiperPatrocinadoresServicos = new Swiper(".swiper-banner-patrocinadores-servicos", {
    spaceBetween: 16,
    pagination: {
        el: ".swiper-banner-patrocinadores-servicos .swiper-pagination",
        clickable: true,
        type: "bullets"
    },
    autoplay: {
        delay: 3000
    }
});
const $ad253d60d7afe5ec$var$swiperPatrocinadoresEspacos = new Swiper(".swiper-banner-patrocinadores-espacos", {
    spaceBetween: 16,
    pagination: {
        el: ".swiper-banner-patrocinadores-espacos .swiper-pagination",
        clickable: true,
        type: "bullets"
    },
    autoplay: {
        delay: 3000
    }
});
const $ad253d60d7afe5ec$var$swiperHome = new Swiper(".swiper-banner-home", {
    spaceBetween: 16,
    pagination: {
        el: ".swiper-banner-home .swiper-pagination",
        clickable: true,
        type: "bullets"
    },
    autoplay: {
        delay: 5000
    }
});
if ($ad253d60d7afe5ec$var$pageHome) {
    (0, $4937a915b72f1eb1$export$2e2bcd8739ae039)();
    (0, $a2fe33a53a5b512b$export$2e2bcd8739ae039)();
    (0, $794158d2cb9595d4$export$2e2bcd8739ae039)();
    // ( in home parameter )
    (0, $54063a1d5a1c34b8$export$2e2bcd8739ae039)(true);
    (0, $aab9032fd0080b40$export$2e2bcd8739ae039)();
    const programacaoWrapper = document.querySelector("#programacao");
    programacaoWrapper && programacaoWrapper.addEventListener("click", (e)=>{
        const target = e.target.closest(".continuar-lendo");
        if (!target) return;
        console.log(target, "target");
        const parentTarget = target.closest(".content-for-p");
        parentTarget.classList.toggle("open");
    });
    gsap.to(".body_home .ingresos-fixed", {
        scrollTrigger: {
            trigger: "#banner-home",
            start: "top+=50px"
        },
        y: 0
    });
} else if ($ad253d60d7afe5ec$var$pageBlog) {
    const swiperDestaque = new Swiper(".swiper-destaque", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 32
            }
        }
    });
} else if ($ad253d60d7afe5ec$var$pageSingle) {
    // swiper-midia
    (0, $c86aaadf1fefcf52$export$ed80d9de1d9df928)();
    (0, $80fb6b98aeaeaa4f$export$2e2bcd8739ae039)();
    (0, $387cb6fd3b6f5399$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageOevento) {
    (0, $23d1a14caa12f6a2$export$2e2bcd8739ae039)();
    (0, $f8482878227b673c$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageQuemSomos) {
    const swiperFotos = new Swiper(".swiper-fotos", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        breakpoints: {
            1024: {
                slidesPerView: "auto",
                spaceBetween: 24
            }
        }
    });
    const swiperNossaHistoria = new Swiper(".swiper-nossa-historia", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-nossa-historia .pagination",
            type: "fraction",
            renderFraction: function(currentClass, totalClass) {
                console.log(currentClass);
                return '<span class="' + currentClass + '"></span>' + " DE " + '<span class="' + totalClass + '"></span>';
            }
        },
        navigation: {
            nextEl: ".swiper-nossa-historia .button-right",
            prevEl: ".swiper-nossa-historia .button-left"
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 32
            }
        }
    });
    (0, $5a9a2a7fbd22e317$export$2e2bcd8739ae039)();
    Fancybox.bind('[data-fancybox="quem-somos-galeria"]', {
    });
} else if ($ad253d60d7afe5ec$var$pageComingSoon) (0, $ac2821ef72d32b9d$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageProgramacaoExpositorEAutografros) {
    const toggleFilter = document.querySelector(".filtrar-por-data");
    toggleFilter && toggleFilter.addEventListener("click", ()=>{
        const sidebar = document.querySelector(".sidebar");
        sidebar.classList.toggle("open");
    });
    (0, $afa81d98f5c9aac5$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageProgramacao) {
    (0, $54063a1d5a1c34b8$export$2e2bcd8739ae039)();
    (0, $aab9032fd0080b40$export$2e2bcd8739ae039)();
    const swiperInfiniteProgramacao = new Swiper(".swiper-infinite-programacao", {
        slidesPerView: "auto",
        allowTouchMove: false,
        spaceBetween: 40,
        speed: 2000,
        loop: true,
        autoplay: {
            delay: 0
        },
        breakpoints: {
            1024: {
                spaceBetween: 64
            }
        }
    });
    const toggleFilter = document.querySelector(".filtrar-por-data");
    toggleFilter && toggleFilter.addEventListener("click", ()=>{
        const sidebar = document.querySelector(".sidebar");
        sidebar.classList.toggle("open");
    });
    const programacaoWrapper = document.querySelector(".programacoes");
    programacaoWrapper && programacaoWrapper.addEventListener("click", (e)=>{
        const target = e.target.closest(".continuar-lendo");
        if (!target) return;
        const parentTarget = target.closest(".content-for-p");
        parentTarget.classList.toggle("open");
    });
} else if ($ad253d60d7afe5ec$var$pageAtracoes) {
    (0, $aab9032fd0080b40$export$2e2bcd8739ae039)();
    const urlParams = new URLSearchParams(window.location.search);
    const nomeValue = urlParams.get("nome");
    // Display the value in an HTML element
    const outputElement = document.querySelector(".busca input[name=nome]");
    if (nomeValue) outputElement.value = nomeValue;
    else outputElement.value = "";
} else if ($ad253d60d7afe5ec$var$pageContato) {
    const swiperInfiniteProgramacao = new Swiper(".swiper-infinite-programacao", {
        slidesPerView: "auto",
        allowTouchMove: false,
        spaceBetween: 20,
        speed: 4000,
        loop: true,
        autoplay: {
            delay: 0
        },
        breakpoints: {
            1024: {
                spaceBetween: 64
            }
        }
    });
    (0, $a2fe33a53a5b512b$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageCredenciamento) (0, $66ac328110c8fab9$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageVisitantes) {
    const sideTitles = document.querySelectorAll(".side-bar h2");
    const blockItems = document.querySelectorAll(".col-informacoes  .block-item");
    sideTitles.forEach((item, index)=>{
        item.addEventListener("click", (e)=>{
            sideTitles.forEach((i)=>i.classList.remove("active"));
            item.classList.add("active");
            const gotoblock = blockItems[index];
            if (gotoblock) gotoblock.scrollIntoView();
        // console.log(blockItems[index])
        });
    });
} else if ($ad253d60d7afe5ec$var$pageEspacos) {
    const swiperCategoriaEspaco = new Swiper(".swiper-categoria-espaco", {
        slidesPerView: "auto",
        navigation: {
            nextEl: "#categorias .swiper-button-next",
            prevEl: "#categorias .swiper-button-prev"
        }
    });
    const swiperCuradores = new Swiper(".swiper-curadores", {
        slidesPerView: 2.2,
        spaceBetween: 16,
        breakpoints: {
            1024: {
                slidesPerView: 5
            }
        }
    });
    const swiperEspaco = new Swiper(".swiper-espaco", {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-espaco .pagination",
            type: "fraction",
            renderFraction: function(currentClass, totalClass) {
                console.log(currentClass);
                return '<span class="' + currentClass + '"></span>' + " DE " + '<span class="' + totalClass + '"></span>';
            }
        },
        navigation: {
            nextEl: ".swiper-espaco .button-right",
            prevEl: ".swiper-espaco .button-left"
        }
    });
    const todosEspacos = document.querySelectorAll(".espaco");
    const allTabs = document.querySelectorAll("#categorias .tab");
    allTabs && allTabs.forEach((tab)=>{
        tab.addEventListener("click", (e)=>{
            const target = e.target.closest(".tab");
            if (!target) return;
            allTabs.forEach((es)=>es.classList.remove("active"));
            target.classList.add("active");
            const id = target.dataset.id;
            const espaco = document.querySelector(`#${id}`);
            if (espaco) {
                todosEspacos.forEach((es)=>es.classList.remove("show"));
                console.log(espaco);
                espaco.classList.add("show");
            }
        });
    });
} else if ($ad253d60d7afe5ec$var$pageServicos) {
    const swiperCategoriaEspaco = new Swiper(".swiper-categoria-espaco", {
        slidesPerView: "auto",
        navigation: {
            nextEl: "#categorias .swiper-button-next",
            prevEl: "#categorias .swiper-button-prev"
        }
    });
    const swiperEspaco = new Swiper(".swiper-espaco", {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-espaco .pagination",
            type: "fraction",
            renderFraction: function(currentClass, totalClass) {
                console.log(currentClass);
                return '<span class="' + currentClass + '"></span>' + " DE " + '<span class="' + totalClass + '"></span>';
            }
        },
        navigation: {
            nextEl: ".swiper-espaco .button-right",
            prevEl: ".swiper-espaco .button-left"
        }
    });
    document.addEventListener("DOMContentLoaded", function() {
        var tabs = document.querySelectorAll(".tab");
        tabs.forEach((tab)=>{
            tab.addEventListener("click", function() {
                tabs.forEach((item)=>item.classList.remove("active"));
                tab.classList.add("active");
                var tabNumber = tab.querySelector("p").classList[0].split("-")[1];
                var targetArticle = document.getElementById("servico-" + tabNumber);
                var articles = document.querySelectorAll(".espaco");
                articles.forEach((article)=>article.classList.remove("active"));
                targetArticle.classList.add("active");
            });
        });
    });
} else if ($ad253d60d7afe5ec$var$pageExpositores) {
    const lettersDropDown = document.querySelector(".floating-letters");
    const selectToClick = document.querySelector(".filtro-to-click");
    selectToClick && selectToClick.addEventListener("click", (e)=>{
        const target = e.target.closest(".filtro-to-click");
        if (!target) return;
        target.classList.toggle("show");
    });
    (0, $4928a42df9327267$export$2e2bcd8739ae039)();
}
// INIT YOUTUBE 
if (window.Fancybox) Fancybox.bind('[data-fancybox="youtube"]', {
});
document.addEventListener("DOMContentLoaded", ()=>{
    document.body.classList.add("dcl");
    // Get the element with the class "ingresos-fixed"
    const ingresosFixedElement = document.querySelector(".ingresos-fixed");
    const footerElement = document.getElementById("footer-bienal");
    // Get the height of the "ingresos-fixed" element
    if (ingresosFixedElement && footerElement) {
        console.log("runned ?");
        const ingresosFixedHeight = ingresosFixedElement.clientHeight;
        footerElement.style.paddingBottom = `${ingresosFixedHeight}px`;
    }
    // Add padding to the element with the ID "footer"
    jQuery.fn.FCInstagram.accessData = {
        accessToken: "IGAASPEiRjZBYFBZAE5DTXZAtRlo4cWVVSGFMSTNZASGlTRUhueW5rUm1jMVVaSjY0cDI5aXp6XzVKdkk5cFU1NEdxVHc3aENKTF9FT0RubTFMOGg4ZA2c5WXNfcmdnRmYwTW92X0traGdFRGhmZADJfazFGSllOVHpqZA3hxSXdUdXlBRQZDZD" // Token
    };
    $("#instafeed").FCInstagram({
        max: 4,
        autoplay: true,
        complete: function() {
            console.log("completed");
            const instaItems = document.querySelectorAll("#instafeed a");
            instaItems.forEach((item)=>{
                const htmlHover = `<div class="content-hover">
                <svg>
                  <use xlink:href="#icon_instagram"></use>
                </svg>
                <p class="see-insta">Ver no instagram</p>
                <svg class="click-icon"> 
                  <use xlink:href="#icon_click"></use>
                </svg>
              </div>`;
                item.insertAdjacentHTML("beforeend", htmlHover);
            });
            console.log(instaItems);
        }
    });
});

})();
//# sourceMappingURL=main.js.map
